<template>
  <div class="error">
    <img :src="imgUrl" alt="" />
    <h1>{{ head }}</h1>
    <div class="content">{{ message }}</div>
    <button @click="closePage">我知道了</button>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'LowVersion',

  data() {
    return {
      head: '版本过低',
      message: '请先升级APP到最新版本，再来尝试',
      imgUrl: '//vfile.meituan.net/scarlett/a881406362184c228b9db739a8bc4e427924.png',
    };
  },

  created() {
    KNB.ready(() => {
      KNB.setLLButton({
        icon: 'H5_Back',
        handle: () => {
          KNB.closePage({});
        },
      });
    });
  },

  methods: {
    closePage() {
      KNB.ready(() => {
        KNB.closeWebview({});
      });
    },
  },
});
</script>

<style lang="less" scoped>
.error {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  img {
    display: block;
    width: 3rem;
    height: 3rem;
    margin: 0.4rem auto;
  }
  h1 {
    margin-top: 0.2rem;
    font-size: 0.36rem;
    text-align: center;
  }
  .content {
    color: #999;
    font-size: 0.28rem;
    margin: 0.1rem 0.8rem 0;
    text-align: center;
  }
  button {
    margin: 0.46rem 0.3rem;
    padding: 0.27rem 0.24rem;
    font-size: 0.32rem;
    color: #fff;
    width: calc(100% - 0.6rem);
    line-height: 1.2;
    border-radius: 0.08rem;
    font-weight: 700;
    background-color: #00cecc;
    border: 1px solid #00cecc;
  }
  button:active {
    background-color: #80e7e6;
    border-color: #80e7e6;
  }
}
</style>
